import React from 'react';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from './design-system';

// Landing Page Components
import ParticleField from './components/ParticleField';
import Header from './components/Header';
import Hero from './components/Hero';
import Stats from './components/Stats';
import HowItWorks from './components/HowItWorks';
import Partners from './components/Partners';
import Footer from './components/Footer';

// DeFi Application Components
import MainLayout from './layouts/MainLayout';
import Dashboard from './pages/Dashboard';
import Vault from './pages/Vault';
import Swap from './pages/Swap';
import Bridge from './pages/Bridge';
import Wallet from './pages/Wallet';

// Landing Page Component
const LandingPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-100 via-gray-50 to-slate-200 relative overflow-hidden">
      <Header />
      
      <main className="relative z-10">
        {/* Optimized section spacing */}
        <Hero />
        <Stats />
        <HowItWorks />
        <Partners />
      </main>
      
      <Footer />
    </div>
  );
};

// Main App with Router
const App: React.FC = () => {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          {/* Landing Page Route */}
          <Route path="/" element={<LandingPage />} />
          
          {/* DeFi Application Routes */}
          <Route path="/app" element={<MainLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="vault" element={<Vault />} />
            <Route path="swap" element={<Swap />} />
            <Route path="bridge" element={<Bridge />} />
            <Route path="wallet" element={<Wallet />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
};

export default App; 